(function () {
    'use strict';
    angular.module('app').directive('selectioncommandcheckin', selectioncommand_checkin);
    function selectioncommand_checkin() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                checkInDialogShown: '=?'
            },
            controller: 'checkin',
            templateUrl: 'app/selectioncommand/selectioncommand_checkin.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();